export default "__VITE_PUBLIC_ASSET__5cea886f__"